import { Action } from '@ngrx/store';

export const REFRESH_LIST_TYPE = `Pillar Metadata Refresh List`;

export class RefreshListAction implements Action {
  readonly identifier = new Date().getTime().toString();
  readonly type = REFRESH_LIST_TYPE;

  constructor() {}
}


// WEBPACK FOOTER //
// ./src/app/pillar/workspace/store/actions/RefreshListAction.ts